import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccountEditorComponent } from './account-editor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { TrackByPropPipeModule } from '@go-modules/pipes/track-by-prop/track-by-prop-pipe.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		FocusOnFirstInvalidFieldModule,
		GoMaterialModule,
		TrackByPropPipeModule
	],
	exports: [
		AccountEditorComponent
	],
	declarations: [
		AccountEditorComponent
	]
})
export class AccountEditorModule {}
